import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import ButtonCircle from "../../../components/Common/ButtonCircle";
import {selectUser} from "../../../slices/profile";
import "./style.scss";
import LinkIcon from "@material-ui/icons/Link";
import {ROUTES, SUBDOMAIN_URL} from "../../../db/models/const";
import {openAlert} from "../../../slices/alert";
import {useTranslation} from "react-i18next";
import GroupIcon from "@material-ui/icons/Group";
import Avatar from "../../../components/Avatar/main";
import { SchoolInterface } from "../../../db/models/school";
import { StudentInterface } from "../../../db/models/student/student";
import { getStudentsByReferral } from "../../../api/student";
import {
	getSchoolDiversityPercentage,
} from "../../../helpers/school";
import pieChart from "./assets/pie-chart.gif";
import radarChart from "./assets/radar-chart.gif";
import mock1 from "./assets/mock1.svg";
import mock2 from "./assets/mock2.svg";
import mock3 from "./assets/mock3.svg";
import mock4 from "./assets/mock4.svg";

interface Props {
}

const SchoolDashboard: React.FC<Props> = () => {
    const dispatch = useDispatch();
    const user: SchoolInterface = useSelector(selectUser) as SchoolInterface;
    const {t} = useTranslation();
    const [newStudents, setNewStudents] = useState<StudentInterface[]>([]);
    const diversity = getSchoolDiversityPercentage(user);

    useEffect(() => {
        if (!user) return;

        getStudentsByReferral().then((students) => {
            setNewStudents(students);
        });
    }, [user]);

    const copyStudentSignupLink = async () => {
        await navigator.clipboard.writeText(
            `${SUBDOMAIN_URL}${ROUTES.SIGNUP_STUDENT_SCHOOL}?referral=${user.id}`
        );
        dispatch(openAlert({type: "success", message: t("alert_clipboard")}));
    };

    return (
        <div className="schoolDashboard">
            <div className="schoolDashboard__topRow">
                <div className="schoolDashboard__name card">
                    <img src={user?.logoUrl} width={90} height={90} alt="logo"/>
                    <h2>{user.name}</h2>
                    <ButtonCircle onClick={copyStudentSignupLink}>
                        <LinkIcon/>
                    </ButtonCircle>
                </div>
                <div className="schoolDashboard__studentCounters card">
                    <h3>Studenti</h3>
                    <div className="schoolDashboard__studentCountersEntry">
                        <div className="schoolDashboard__peopleIcon">
                            <GroupIcon/>
                        </div>
                        <div>
                            <h4>Iscritti</h4>
                            <p>{user.studentReferralCount}</p>
                        </div>
                    </div>
                    <div className="schoolDashboard__studentCountersEntry">
                        <div className="schoolDashboard__peopleIcon">
                            <GroupIcon/>
                        </div>
                        <div>
                            <h4>Nei vivai</h4>
                            <p className="comingSoon">Coming Soon</p>
                        </div>
                    </div>
                </div>
                <div className="schoolDashboard__column">
                    <div className="schoolDashboard__diversity card">
                        <div className="schoolDashboard__peopleIcon">
                            <GroupIcon/>
                        </div>
                        <div>
                            <h4>Diversity</h4>
                            {diversity !== 0 && <p>{diversity + "%"}</p>}
                            {diversity === 0 && <p className="comingSoon">Coming soon</p>}
                        </div>
                    </div>
                    <div className="schoolDashboard__badge card">
                        <div className="schoolDashboard__peopleIcon">
                            <GroupIcon/>
                        </div>
                        <div>
                            <h4>Badge ottenuti</h4>
                            <p className="comingSoon">Coming soon</p>
                        </div>
                    </div>
                </div>
                <div className="schoolDashboard__newStudents card">
                    <h3>Nuovi iscritti</h3>
                    <div className="schoolDashboard__newStudentsList">
                        {newStudents.map((student) => (
                            <Avatar source={student.photoUrl} radius={48}/>
                        ))}
                    </div>
                    {/* <div className="schoolDashboard__moreInfo">
					<Button light onClick={() => null}>
						Vedi tutti
						<ArrowForwardIcon />
					</Button>
				</div> */}
                </div>
            </div>

			<h2>Dashboard</h2>
			<div className="schoolDashboard__comingSoonRow">
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={mock1} alt="ph"/>
				</div>
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={pieChart} alt="ph"/>
				</div>
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={radarChart} alt="ph"/>
				</div>
			</div>

			<h2>Attività</h2>
			<div className="schoolDashboard__comingSoonRow">
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={mock2} alt="ph"/>
				</div>
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={mock3} alt="ph"/>
				</div>
				<div className="schoolDashboard__comingSoonRowCard">
					<img src={mock4} alt="ph"/>
				</div>
			</div>
		</div>
	);
};

export default SchoolDashboard;
